/**
 * The modal shell. Its content is chosen by whichever modal is open.
 *
 * The backdrop is a real button rather than a div with a click handler, so
 * dismissing by clicking away is reachable from the keyboard too.
 */

import { type Component, Match, Switch } from 'solid-js';
import { modal, setModal } from '../../state/ui.ts';
import { Close } from '../icons/nav.tsx';
import glass from '../primitives/Glass.module.css';
import { GlassButton } from '../primitives/Glass.tsx';
import { ApiKeys } from './ApiKeys.tsx';
import { Help } from './Help.tsx';
import styles from './Modal.module.css';
import { Settings } from './Settings.tsx';

const TITLES = { help: 'Turntable', settings: 'Settings', keys: 'API keys' } as const;

const close = (): void => {
  setModal(null);
};

const title = (): string => {
  const kind = modal();
  return kind ? TITLES[kind] : '';
};

export const Modal: Component = () => (
  <div data-testid="modal" class={[styles.wrap, { [styles.shown as string]: modal() !== null }]}>
    <button type="button" class={styles.backdrop} aria-label="Dismiss" onClick={close} />

    <div class={[glass.glass, styles.modal]} role="dialog" aria-modal="true" aria-label={title()}>
      <header class={styles.head}>
        <h2 data-testid="modal-title">{title()}</h2>
        <GlassButton small label="Close" onClick={close}>
          <Close />
        </GlassButton>
      </header>

      <div class={styles.body} data-testid="modal-body">
        <Switch>
          <Match when={modal() === 'help'}>
            <Help />
          </Match>
          <Match when={modal() === 'settings'}>
            <Settings />
          </Match>
          <Match when={modal() === 'keys'}>
            <ApiKeys />
          </Match>
        </Switch>
      </div>
    </div>
  </div>
);
